/**
 * Theme custom scripts — extend here without editing core theme JS.
 * Preorder CTA + line-item properties from variant metafields.
 */
(function () {
  var PREORDER_LABEL = (window.variantStrings && window.variantStrings.preorder) || 'Preorder';

  function mergePreorderMaps() {
    window.__yanaPreorderVariants = window.__yanaPreorderVariants || {};
    document.querySelectorAll('[data-yana-preorder-variants]').forEach(function (node) {
      if (node.dataset.yanaPreorderParsed) return;
      try {
        var map = JSON.parse(node.textContent);
        Object.keys(map).forEach(function (id) {
          var incoming = map[id];
          var existing = window.__yanaPreorderVariants[id];
          if (existing && existing.inventory_quantity != null) {
            incoming.inventory_quantity = existing.inventory_quantity;
            incoming.available = existing.available;
          }
          window.__yanaPreorderVariants[id] = incoming;
        });
        node.dataset.yanaPreorderParsed = 'true';
      } catch (error) {
        /* ignore invalid JSON */
      }
    });
  }

  function getPreorderConfig(variantId) {
    if (variantId == null || variantId === '') return null;
    mergePreorderMaps();
    var map = window.__yanaPreorderVariants || {};
    return map[String(variantId)] || map[Number(variantId)] || null;
  }

  function currentVariantId() {
    var input = document.querySelector('product-form input[name="id"]');
    return input && input.value;
  }

  function shipDateTemplate(date) {
    var template = window.variantStrings && window.variantStrings.preorderShip;
    if (template) {
      return template.replace(/__DATE__/g, date).replace(/\{\{\s*date\s*\}\}/g, date);
    }
    return 'Estimated shipping ' + date + '.';
  }

  function shouldShowPreorder(config) {
    if (!config || !config.enabled) return false;
    if (typeof config.show_preorder === 'boolean') return config.show_preorder;

    var qty = Number(config.inventory_quantity);
    if (!Number.isFinite(qty)) qty = 0;
    var cap = config.cap == null || config.cap === '' ? null : Number(config.cap);
    var continueSelling = config.inventory_policy === 'continue';

    if (cap != null && !Number.isNaN(cap)) {
      if (qty <= 0) return continueSelling;
      return qty < cap;
    }

    return qty > 0 || continueSelling;
  }

  function linePropertiesFromConfig(config) {
    if (!shouldShowPreorder(config)) return null;
    var props = {
      Preorder: 'Yes',
      _preorder: 'true',
    };
    if (config.ship_date) props['Estimated ship date'] = config.ship_date;
    if (config.type) props._preorder_type = String(config.type);
    return props;
  }

  function isSoldOut(config) {
    if (!config || !config.enabled) return false;
    var qty = Number(config.inventory_quantity) || 0;
    return qty <= 0 && config.inventory_policy !== 'continue' && !config.available;
  }

  function applyPreorder(variantId) {
    variantId = variantId || currentVariantId();

    document.querySelectorAll('product-form').forEach(function (formRoot) {
      var idInput = formRoot.querySelector('input[name="id"]');
      var formVariantId = (idInput && idInput.value) || variantId;
      var config = getPreorderConfig(formVariantId);
      var showPreorder = shouldShowPreorder(config);
      var soldOut = isSoldOut(config);
      var button = formRoot.querySelector('.product-form__submit, .quick-add__submit');
      var textEl = button && button.querySelector(':scope > span');
      var isLoading = button && button.classList.contains('loading');
      var preorderLabel = (window.variantStrings && window.variantStrings.preorder) || PREORDER_LABEL;
      var addLabel = (window.variantStrings && window.variantStrings.addToCart) || 'Add to Shopping Bag';
      var soldOutLabel = (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';

      formRoot.querySelectorAll('[data-preorder-field]').forEach(function (input) {
        var field = input.getAttribute('data-preorder-field');
        if (!showPreorder) {
          input.disabled = true;
          return;
        }
        if (field === 'type') input.value = 'Yes';
        if (field === 'ship') {
          input.value = config.ship_date || '';
          input.disabled = !config.ship_date;
          return;
        }
        if (field === 'flag') input.value = 'true';
        if (field === 'kind') input.value = config.type || '';
        input.disabled = false;
      });

      if (!button || isLoading) return;

      // Leave the button alone unless this size is enrolled in theme preorder,
      // so STOQ / Restock Rocket back-in-stock widgets can own sold-out CTAs.
      if (!config || !config.enabled) {
        button.classList.remove('yana-preorder-button');
        return;
      }

      if (soldOut) {
        if (textEl) textEl.textContent = soldOutLabel;
        button.setAttribute('disabled', 'disabled');
        button.classList.toggle('yana-preorder-button', Boolean(config && config.enabled));
        return;
      }

      if (showPreorder) {
        if (textEl) textEl.textContent = preorderLabel;
        button.removeAttribute('disabled');
        button.removeAttribute('aria-disabled');
        button.classList.add('yana-preorder-button');
      } else {
        if (textEl && config && config.enabled) textEl.textContent = addLabel;
        if (config && config.enabled) {
          button.removeAttribute('disabled');
          button.removeAttribute('aria-disabled');
        }
        button.classList.remove('yana-preorder-button');
      }
    });

    document.querySelectorAll('[id^="PreorderShipNote-"]').forEach(function (noteRoot) {
      var scope = noteRoot.closest('product-info') || document;
      var idInput = scope.querySelector('product-form input[name="id"]');
      var config = getPreorderConfig((idInput && idInput.value) || variantId);
      if (!shouldShowPreorder(config) || !config.ship_date) {
        noteRoot.innerHTML = '';
        return;
      }
      var p = noteRoot.querySelector('[data-preorder-ship-date]') || document.createElement('p');
      p.className = 'preorder-note caption';
      p.setAttribute('data-preorder-ship-date', '');
      p.textContent = shipDateTemplate(config.ship_date);
      if (!p.parentNode) noteRoot.appendChild(p);
    });

    return shouldShowPreorder(getPreorderConfig(variantId));
  }

  function observeSubmitButtons() {
    if (typeof MutationObserver === 'undefined') return;

    document.querySelectorAll('product-form .product-form__submit, product-form .quick-add__submit').forEach(function (button) {
      if (button.dataset.yanaPreorderObserved) return;
      button.dataset.yanaPreorderObserved = 'true';
      new MutationObserver(function () {
        if (button.classList.contains('loading')) return;
        var formRoot = button.closest('product-form');
        var idInput = formRoot && formRoot.querySelector('input[name="id"]');
        var config = getPreorderConfig(idInput && idInput.value);
        if (!config || !config.enabled) return;
        var textEl = button.querySelector(':scope > span');
        if (!textEl) return;
        var preorderLabel = (window.variantStrings && window.variantStrings.preorder) || PREORDER_LABEL;
        var addLabel = (window.variantStrings && window.variantStrings.addToCart) || 'Add to Shopping Bag';
        var soldOutLabel = (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';

        if (isSoldOut(config)) {
          if (textEl.textContent.trim() !== soldOutLabel) textEl.textContent = soldOutLabel;
          return;
        }
        if (shouldShowPreorder(config)) {
          if (textEl.textContent.trim() !== preorderLabel) textEl.textContent = preorderLabel;
          if (button.hasAttribute('disabled')) button.removeAttribute('disabled');
          if (button.getAttribute('aria-disabled') === 'true') button.removeAttribute('aria-disabled');
          return;
        }
        if (config && config.enabled && textEl.textContent.trim() === preorderLabel) {
          textEl.textContent = addLabel;
        }
      }).observe(button, { childList: true, subtree: true, characterData: true, attributes: true });
    });
  }

  function nativeFetch(url, options) {
    var fetchFn = window.fetch.bind(window);
    return fetchFn(url, options);
  }

  function isPreorderLine(item) {
    var props = item.properties || {};
    var flag = props._preorder;
    var label = props.Preorder;
    return flag === 'true' || flag === true || label === 'Yes' || label === 'true' || label === true;
  }

  var NOTE_START = '--- Preorder ---';
  var NOTE_END = '--- End preorder ---';
  var cartMetaSyncing = false;

  function stripPreorderNoteBlock(note) {
    if (!note) return '';
    return note.replace(/(?:\n)?--- Preorder ---[\s\S]*?--- End preorder ---(?:\n)?/g, '').trim();
  }

  function buildPreorderNoteBlock(cart) {
    var lines = (cart.items || []).filter(isPreorderLine);
    if (!lines.length) return '';
    var preCount = lines.length;
    var otherCount = (cart.items || []).length - preCount;
    var rows = lines.map(function (item) {
      var title = item.product_title || item.title || 'Item';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? ' – ' + item.variant_title : '';
      var qty = item.quantity ? ' × ' + item.quantity : '';
      var ship = (item.properties && item.properties['Estimated ship date']) || '';
      var shipText = ship ? ' — estimated ship: ' + ship : '';
      return '- ' + title + variant + qty + shipText;
    });
    var header = otherCount > 0 ? 'Preorder items in this mixed order:' : 'Preorder items:';
    return NOTE_START + '\n' + header + '\n' + rows.join('\n') + '\n' + NOTE_END;
  }

  function mergePreorderNote(existingNote, block) {
    var rest = stripPreorderNoteBlock(existingNote);
    if (!block) return rest;
    return rest ? rest + '\n\n' + block : block;
  }

  function orderKindFromCart(cart) {
    var pre = 0;
    var other = 0;
    (cart.items || []).forEach(function (item) {
      if (isPreorderLine(item)) pre += 1;
      else other += 1;
    });
    if (pre && other) return 'mixed';
    if (pre) return 'preorder';
    return '';
  }

  function syncCartPreorderMeta() {
    if (cartMetaSyncing) return Promise.resolve();
    cartMetaSyncing = true;
    return nativeFetch('/cart.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var kind = orderKindFromCart(cart);
        var nextNote = mergePreorderNote(cart.note, buildPreorderNoteBlock(cart));
        var currentKind = (cart.attributes && (cart.attributes.preorder_status || cart.attributes._preorder_order)) || '';
        var currentNote = cart.note || '';
        if (nextNote === currentNote && currentKind === kind) {
          cartMetaSyncing = false;
          return null;
        }
        return nativeFetch('/cart/update.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            note: nextNote,
            attributes: {
              preorder_status: kind,
              _preorder_order: kind,
            },
          }),
        }).then(function (res) {
          return res.json();
        });
      })
      .catch(function (error) {
        console.error(error);
      })
      .then(function () {
        cartMetaSyncing = false;
      });
  }

  window.yanaPreorderLineProperties = function (variantId) {
    return linePropertiesFromConfig(getPreorderConfig(variantId));
  };

  window.syncYanaCartPreorderMeta = syncCartPreorderMeta;

  function bindCheckoutAttributeSync() {
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || form.nodeName !== 'FORM') return;
        if (form.dataset.yanaPreorderSynced === 'true') return;
        if (!form.querySelector('[name="checkout"]')) return;
        event.preventDefault();
        event.stopPropagation();
        syncCartPreorderMeta().finally(function () {
          form.dataset.yanaPreorderSynced = 'true';
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.submit();
        });
      },
      true
    );
  }

  window.adjustYanaPreorderInventory = function (variantId, delta) {
    var config = getPreorderConfig(variantId);
    if (!config) return;
    var qty = Number(config.inventory_quantity);
    if (!Number.isFinite(qty)) qty = 0;
    config.inventory_quantity = Math.max(0, qty + Number(delta || 0));
    if (config.inventory_quantity <= 0 && config.inventory_policy !== 'continue') {
      config.available = false;
    } else if (config.inventory_quantity > 0) {
      config.available = true;
    }
  };

  window.syncYanaPreorderButton = function (variantId) {
    variantId = variantId || currentVariantId();
    if (!variantId) return false;
    observeSubmitButtons();
    applyPreorder(variantId);
    [0, 50, 150, 350, 700].forEach(function (delay) {
      setTimeout(function () {
        applyPreorder(variantId);
      }, delay);
    });
    return shouldShowPreorder(getPreorderConfig(variantId));
  };

  document.addEventListener(
    'change',
    function (event) {
      if (event.target && event.target.matches && event.target.matches('product-form input[name="id"]')) {
        window.syncYanaPreorderButton(event.target.value);
      }
    },
    true
  );

  document.addEventListener('DOMContentLoaded', function () {
    mergePreorderMaps();
    observeSubmitButtons();
    window.syncYanaPreorderButton(currentVariantId());
    bindCheckoutAttributeSync();
    syncCartPreorderMeta();
  });

  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var payload = event && event.data;
    var variant = payload && payload.variant;
    if (variant) {
      var config = getPreorderConfig(variant.id);
      if (config && variant.inventory_quantity != null) {
        config.inventory_quantity = variant.inventory_quantity;
        config.available = variant.available;
      }
      window.syncYanaPreorderButton(variant.id);
    }
    if (!payload || !payload.variant || !payload.sectionId) return;

    var container = document.getElementById('price-' + payload.sectionId);
    if (!container) return;

    var priceRoot = container.querySelector('.price');
    if (!priceRoot) return;

    var v = payload.variant;
    var compareAt = v.compare_at_price;
    var price = v.price;
    var volumePricing = priceRoot.getAttribute('data-volume-pricing') === 'true';
    var soldOut = !v.available;
    var hasCompareSale = compareAt != null && compareAt > price;

    priceRoot.classList.toggle('price--sold-out', soldOut);
    priceRoot.classList.toggle('price--on-sale', hasCompareSale && !volumePricing);
    priceRoot.classList.toggle('volume-pricing--sale-badge', hasCompareSale && volumePricing);
  });

  subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
    window.syncYanaPreorderButton(currentVariantId());
    syncCartPreorderMeta();
  });
})();
